import React from 'react';
import { FormattedMessage } from 'react-intl';

export const getDefault404Message = () => (<>
  <h1>404</h1>
  <FormattedMessage id="web.error.page.notfound" defaultMessage="Page not found" tagName="h2" />
  <FormattedMessage id="web.404" defaultMessage="The resource you are looking for cannot be found." />
</>);
